import { globalLayout } from '@atlassian/jira-global-layout/src/index.tsx';
import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import { sandboxRelayEchoPageUsingRLLRoute } from '@atlassian/jira-router-routes-sandbox-routes/src/sandboxRelayEchoPageUsingRLLRoute.tsx';
import { AsyncSandboxEchoPage } from '@atlassian/jira-spa-apps-sandbox-relay/src/ui/AsyncSandboxEchoPage.tsx';
import { MENU_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import { AsyncHorizontalNavJira } from '@atlassian/jira-horizontal-nav/src/async.tsx';
import { sandboxEchoPageRelayResource } from '@atlassian/jira-router-resources-sandbox/src/index.tsx';
import { Skeleton } from './ui/index.tsx';

export const sandboxRelayEchoPageUsingRLLRouteEntry = createEntry(
	sandboxRelayEchoPageUsingRLLRoute,
	() => ({
		group: 'sandbox',
		layout: globalLayout,
		skeleton: Skeleton,
		navigation: {
			menuId: MENU_ID.PROJECTS,
			horizontal: AsyncHorizontalNavJira,
			onlyShowHorizontalOnNav4: true,
		},
		component: AsyncSandboxEchoPage,
		lazyForPaint: [AsyncSandboxEchoPage],
		resources: [sandboxEchoPageRelayResource],
		ufoName: 'sandbox-relay-echo',
		// eslint-disable-next-line jira/route-definitions/entry-standards
		bifrost: {
			bundling: {
				packageName:
					'@atlassian/jira-router-routes-sandbox-entries/src/sandboxRelayEchoPageUsingRLLRouteEntry.tsx',
				whichExportToUse: 'sandboxRelayEchoPageUsingRLLRouteEntry',
			},
			// WARNING: setting this to `true` will cause us to build & deploy the route to bifrost+tesseract instances worldwide, which is quite expensive!
			// enabled: true,
			manifestName: 'jira-spa-sandboxdemo.json',
			bifrostGroup: 'not-deployed',
		},
	}),
);
